import { Pipe, PipeTransform } from '@angular/core';
import {
  CustomOutlookSyncStatus,
  ExtendedOutlookSyncStatus,
  OutlookSyncStatus,
} from '@maximizer/outlook-sync/data-access';

@Pipe({
  name: 'syncStatusIcon',
})
export class SyncStatusIcon implements PipeTransform {
  transform(status: ExtendedOutlookSyncStatus): string {
    switch (status) {
      case OutlookSyncStatus.Syncing:
        return 'icon-refresh text-neutral-90';
      case OutlookSyncStatus.Complete:
        return 'font-bold icon-check text-finserv-100';
      case OutlookSyncStatus.Problem:
        return 'icon-circle-exclamation icon-solid text-error';
      case CustomOutlookSyncStatus.NoPermission:
        return 'icon-lock-keyhole icon-solid text-neutral-90';
      case CustomOutlookSyncStatus.Paused:
        return 'icon-circle-pause text-neutral-90';
      default:
        return 'icon-circle-pause text-neutral-90';
    }
  }
}
